import en from './en.json';
import pl from './pl.json';

const locales = {
  en,
  pl,
};

export default locales;
